import { VetterItem, VetterItemApi } from './vetters.types';

export const normalizeVetters = (items: VetterItemApi[]): VetterItem[] => {
  return items.map((item) => ({
    ...item,
    numDMs: parseInt(item.numDMs),
  }));
};
